export default function EditIcon({
  color = '#9B9DA2',
  width = '19',
  height = '19',
}: {
  color?: string;
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 19 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_19_11473)'>
        <path
          d='M11.8757 18.0106H7.12565C2.8269 18.0106 0.990234 16.1739 0.990234 11.8752V7.12516C0.990234 2.82641 2.8269 0.989746 7.12565 0.989746H8.70898C9.03357 0.989746 9.30273 1.25891 9.30273 1.5835C9.30273 1.90808 9.03357 2.17725 8.70898 2.17725H7.12565C3.47607 2.17725 2.17773 3.47558 2.17773 7.12516V11.8752C2.17773 15.5247 3.47607 16.8231 7.12565 16.8231H11.8757C15.5252 16.8231 16.8236 15.5247 16.8236 11.8752V10.2918C16.8236 9.96725 17.0927 9.69808 17.4173 9.69808C17.7419 9.69808 18.0111 9.96725 18.0111 10.2918V11.8752C18.0111 16.1739 16.1744 18.0106 11.8757 18.0106Z'
          fill={color}
        />
        <path
          d='M6.72881 14.0047C6.2459 14.0047 5.80256 13.8306 5.47798 13.5139C5.09006 13.126 4.92381 12.5639 5.0109 11.9701L5.35131 9.58722C5.41465 9.12806 5.71548 8.53431 6.04006 8.20972L12.2784 1.97136C13.8538 0.395941 15.4529 0.395941 17.0284 1.97136C17.8913 2.83427 18.2792 3.71302 18.2 4.59177C18.1288 5.30427 17.7488 6.00094 17.0284 6.71344L10.79 12.9518C10.4654 13.2764 9.87169 13.5772 9.41252 13.6406L7.02965 13.981C6.92673 14.0047 6.82381 14.0047 6.72881 14.0047ZM13.1175 2.81052L6.87923 9.04889C6.72881 9.19931 6.55465 9.54764 6.52298 9.75347L6.18256 12.1364C6.1509 12.366 6.1984 12.556 6.31715 12.6747C6.4359 12.7935 6.6259 12.841 6.85548 12.8093L9.23836 12.4689C9.44419 12.4372 9.80044 12.2631 9.94294 12.1126L16.1813 5.87427C16.6959 5.35969 16.965 4.90052 17.0046 4.47302C17.0521 3.95844 16.7829 3.41219 16.1813 2.80261C14.9146 1.53594 14.0438 1.89219 13.1175 2.81052Z'
          fill={color}
        />
        <path
          d='M15.7135 7.78197C15.6581 7.78197 15.6027 7.77406 15.5552 7.75822C13.4731 7.17239 11.8185 5.51781 11.2327 3.43572C11.1456 3.11906 11.3277 2.79447 11.6443 2.69947C11.961 2.61239 12.2856 2.79447 12.3727 3.11114C12.8477 4.79739 14.1856 6.13531 15.8718 6.61031C16.1885 6.69739 16.3706 7.02989 16.2835 7.34656C16.2123 7.61572 15.9748 7.78197 15.7135 7.78197Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_19_11473'>
          <rect width='19' height='19' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
